import React from 'react';
import PropTypes from 'prop-types';
import HandlerOptionalRender from "../HandlerOptionalRender";
const ErrorRender = ({
  children,
  error,
  errorComponent
}) => {
  return /*#__PURE__*/React.createElement(HandlerOptionalRender, {
    OptionalComponent: error ? errorComponent : null
  }, children);
};
ErrorRender.defaultProps = {
  children: /*#__PURE__*/React.createElement(React.Fragment, null),
  error: false,
  errorComponent: () => /*#__PURE__*/React.createElement(React.Fragment, null)
};
ErrorRender.propTypes = {
  children: PropTypes.object.isRequired,
  error: PropTypes.bool,
  errorComponent: PropTypes.func
};
export default ErrorRender;